module.exports = __webpack_public_path__ + "img/fireball.06154b8d.svg";